import React from 'react'
import { Security } from '@okta/okta-react'
import { toRelativeUrl } from '@okta/okta-auth-js'
import { useNavigate } from 'react-router-dom'
import oktaAuth from '../../authConfig'

const SecurityProvider = ({ children }) => {
  const navigate = useNavigate()

  const restoreOriginalUri = async (_oktaAuth, originalUri) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), {
      replace: true,
    })
  }

  return (
    <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
      {children}
    </Security>
  )
}

export default SecurityProvider
